import React from "react";
import styles from "./noCalls.module.scss";

type ImageSrc= { voiceMailEmptySrc?:any }
export default function NoCalls({voiceMailEmptySrc}:ImageSrc) {
  return (
    <>
      <div className={styles.noMessage}>
        <div className={styles.noMessageinner}>
          <img src={voiceMailEmptySrc} alt="" />
          <p className={styles.noMessageTitle}>No Logs Found</p>
          {/* <p className={styles.noMessageDesc}>
            Here you will find any message that you have composed but not sent.
            You can read, edit and send anytime you like. Delete the drafts that you do not need.
          </p>
          <div className={styles.recentBtn}>
            <span className="icon_outlineleftarrow"></span>
            <span>no  detail</span>
          </div> */}
        </div>
      </div>
    </>
  );
};
